// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

/* globals require */

// Import third party modules
import angular from 'angular';

const MODULE_NAME = 'video';
angular.module(MODULE_NAME, [])

    .directive('appVideo', () => {
      return {
        scope: {
          videoFilename: '@video',
        },
        replace: true,
        restrict: 'E',
        template: '',
        link: ($scope, element, attrs) => {
          if ($scope.videoFilename) {
            let videoUrl = '';
            try {
              videoUrl = require(`../../public/videos/${ $scope.videoFilename }.mp4`);
            } catch (e) {
            // Unable to locate video
            }
            let posterUrl = '';
            try {
              posterUrl = require(`../../public/video-posters/${ $scope.videoFilename }.jpg`);
            } catch (e) {
            // Unable to locate poster
            }
            const video = document.createElement('video');
            video.setAttribute('autoplay', true);
            video.setAttribute('loop', true);
            video.setAttribute('muted', true);
            video.muted = true;
            video.setAttribute('playsinline', true);
            video.classList.add('u-fill');
            if (posterUrl) {
              video.setAttribute('poster', posterUrl);
            }
            element[0].appendChild(video);
            // let videoLoaded = false;
            // video.addEventListener('canplaythrough', (e) => {
            //   if (!videoLoaded) {
            //     videoLoaded = true;
            //   }
            // });
            video.src = videoUrl;
          }
        },
      };
    });

export default MODULE_NAME;
